import { render, staticRenderFns } from "./FlashCardDeckEditor.vue?vue&type=template&id=7593e652&"
import script from "./FlashCardDeckEditor.vue?vue&type=script&lang=js&"
export * from "./FlashCardDeckEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports